import React from 'react';
import { toast } from 'react-toastify';
import { Row } from 'saladsoft-primitive';

const ExcelButton = ({ onClick }: { onClick: () => void }) => {
  const handleClick = () => {
    onClick();
  };
  return (
    <>
      <Row gap={5} cursor="pointer" onClick={handleClick}>
        <img src="/images/excel.png" style={{ width: 20, height: 20 }} />
        <div style={{ fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}>엑셀출력</div>
      </Row>
    </>
  );
};

export default ExcelButton;
